import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link, useParams } from 'react-router-dom';
import {
  CheckCircleIcon,
  HomeIcon,
  ShoppingBagIcon,
  TruckIcon,
} from '@heroicons/react/24/outline';
import { useCart } from '../contexts/CartContext';
import './OrderSuccess.css';

const OrderSuccess: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { orderNumber } = useParams<{ orderNumber: string }>();
  const { clearCart } = useCart();

  useEffect(() => {
    clearCart();
  }, [clearCart]);

  const handleContinueShopping = () => {
    navigate('/products');
  };

  return (
    <div className="order-success-page">
      <div className="container">
        <div className="success-content">
          <div className="success-icon">
            <CheckCircleIcon className="check-icon" />
          </div>

          <div className="success-message">
            <h1>{t('orderSuccess.title')}</h1>
            <p className="order-number">
              {t('orderSuccess.orderNumber')}{' '}
              <strong>{orderNumber || '—'}</strong>
            </p>
            <p className="confirmation-text">
              {t('orderSuccess.confirmationText')}
            </p>
          </div>

          <div className="order-details">
            <h3>{t('orderSuccess.whatsNext')}</h3>
            <div className="next-steps">
              <div className="step">
                <div className="step-icon">
                  <TruckIcon className="icon" />
                </div>
                <div className="step-content">
                  <h4>{t('orderSuccess.orderProcessing')}</h4>
                  <p>{t('orderSuccess.orderProcessingDescription')}</p>
                </div>
              </div>

              <div className="step">
                <div className="step-icon">
                  <TruckIcon className="icon" />
                </div>
                <div className="step-content">
                  <h4>{t('orderSuccess.shipping')}</h4>
                  <p>{t('orderSuccess.shippingDescription')}</p>
                </div>
              </div>

              <div className="step">
                <div className="step-icon">
                  <CheckCircleIcon className="icon" />
                </div>
                <div className="step-content">
                  <h4>{t('orderSuccess.delivery')}</h4>
                  <p>{t('orderSuccess.deliveryDescription')}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="action-buttons">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleContinueShopping}
            >
              <ShoppingBagIcon className="btn-icon" />
              {t('orderSuccess.continueShopping')}
            </button>

            <Link to="/" className="btn btn-outline">
              <HomeIcon className="btn-icon" />
              {t('orderSuccess.backToHome')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;
